import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';
import store from '@/store';
import Main from '@/app/pages/Main';
import ForgotPassword from '@/app/pages/ForgotPassword';
import RetryConfirm from '@/app/pages/RetryConfirm';
import Organizations from '@/app/pages/Organizations';
import OrganizationAdd from '@/app/pages/OrganizationAdd';
import Error from "@/pages/Error/Error";
import Error403 from "@/pages/Error/Error403";
import Login from "@/pages/Login/Login";
import ResetPassword from '@/app/pages/ResetPassword';
import SocialPage from '@/app/pages/social/SocialPage';
import WorkSpaceSettingsPage from '@/app/pages/WorkSpaceSettingsPage';
import SocialDebtorsPage from '@/app/pages/social/SocialDebtorsPage';
import SocialDebtorsUploadPage from '@/app/pages/social/SocialDebtorsUploadPage';
import MaintenancePage from '@/app/pages/Maintenance/MaintenancePage';
import OrganizationConnection from '@/app/components/connection/OrganizationConnection';
import {isAuthenticatedWithToken} from "./mixins/auth";
import SupportPage from '@/app/pages/SupportPage';
import ApiPage from '@/app/pages/ApiPage';
import AdminImportDebtResponseErrors from '@/app/pages/admin/AdminImportDebtResponseErrors';
import ContrAgentsMain from '@/app/pages/contragents/Main.vue';
// import EXAMPLE_ROUTES from './routes/example';
// import DOCUMENTATION_ROUTES from './routes/docs';

import WorkspaceList from "@/app/components/admin/workspaces/WorkspaceList";

//User
import List from "@/pages/User/List/List";
import Add from "@/pages/User/Add/Add";
import Edit from "@/pages/User/Edit/Edit";
import Profile from "@/app/user/Profile";
// import { mapGetters } from 'vuex'
import HouseFias from '@/app/pages/HouseFias';
import WorkSpaceInvitePage from "./app/pages/WorkSpaceInvitePage.vue";
import WorkSpacePage from "./app/pages/WorkSpacePage.vue";
import JurEditPage from "./app/pages/contragents/JurEditPage.vue";
import ContactCreatePage from "./app/pages/contragents/ContactCreatePage.vue";
import ContactsPage from "./app/pages/contragents/ContactsPage.vue";
import ExportRequestStatisticPage from "./app/pages/admin/ExportRequestStatisticPage.vue";

import Subscriptions from "@/app/components/subscriptions/Subscriptions.vue";
import LayoutSubscription from "@/components/Layout/LayoutSubscription.vue";
import SubscriptionPage from "@/app/components/subscriptions/pages/SubscriptionPage.vue";
import SubscriptionDetailsPage from "@/app/components/subscriptions/pages/SubscriptionDetailsPage.vue";
import SubscriptionPayPage from "@/app/components/subscriptions/pages/SubscriptionPayPage.vue";
import SubscriptionBalance from "@/app/components/subscriptions/pages/SubscriptionBalance.vue";
import SubscriptionInvoices from "@/app/components/subscriptions/pages/SubscriptionInvoices.vue";
import SubscriptionDownloadInvoice from "@/app/components/subscriptions/pages/SubscriptionDownloadInvoice.vue";
import SubscriptionSettingsPage from "@/app/components/subscriptions/pages/SubscriptionSettingsPage.vue";
import SubscriptionSettingsDetailsPage from "@/app/components/subscriptions/pages/SubscriptionSettingsDetailsPage.vue";
import SubscriptionSettingsPayPage from "@/app/components/subscriptions/pages/SubscriptionSettingsPayPage.vue";

import AppealsListPage from "./app/pages/appeals/AppealsListPage.vue";
import AppealsConnectPage from "./app/pages/appeals/AppealsConnectPage.vue";
import AppealsConnectionPendingPage from "./app/pages/appeals/AppealsConnectionPendingPage.vue";

Vue.use(Router);

const routes = [
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    beforeEnter: (to, from, next) => {
      if(isAuthenticatedWithToken()){
        next({name: 'Layout'});
      }else{
        next();
      }
    },
    meta: {
      guest: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: true,
    // beforeEnter: (to, from, next) => {
    //   if(isAuthenticatedWithToken()){
    //     next({name: 'Layout'});
    //   }else{
    //     next();
    //   }
    // },
    meta: {
      guest: true
    }
  },
  {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      props: { email: false },
      beforeEnter: (to, from, next) => {
        if(isAuthenticatedWithToken()){
          next({name: 'Layout'});
        }else{
          next();
        }
      },
      meta: {
        guest: true
      }
    },
    {
      path: '/retry-confirm',
      name: 'RetryConfirm',
      component: RetryConfirm,
      props: { email: false },
      beforeEnter: (to, from, next) => {
        if(isAuthenticatedWithToken()){
          next({name: 'Layout'});
        }else{
          next();
        }
      },
      meta: {
        guest: true
      }
    },
  {
    path: '/work-space/invite/:token',
    name: 'WorkSpaceInvitePage',
    component: WorkSpaceInvitePage,
    meta: {
      guest: true
    }
  },
  {
    path: '/',
    redirect: 'main',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: '/main',
        name: 'Main',
        component: Main
      },
      {
        path: '/organizations/index',
        name: 'Organizations',
        component: Organizations
      },
      {
        path: '/organizations/add',
        name: 'OrganizationAdd',
        component: OrganizationAdd
      },
      {
        path: '/organizations/houses',
        name: 'HouseFias',
        component: HouseFias
      },
      // User
      {
        path: '/user/profile',
        name: 'UserProfile',
        component: Profile
      },
      {
        path: '/user/api',
        name: 'UserApiPage',
        component: ApiPage
      },
      //support
      {
        path: '/support',
        name: 'SuportPage',
        component: SupportPage
      },
    ],
  },

    {
        path: '/social',
        component: Layout,
        children: [
            {
                path: 'requests',
                name: 'Social',
                component: SocialPage
            },
            {
                path: 'person-debtors',
                name: 'SocialPersonDebtors',
                component: SocialDebtorsPage
            },
            {
                path: 'person-debtors/upload/:id?',
                name: 'SocialDebtorsUploadPage',
                component: SocialDebtorsUploadPage,
                props: {initUploadFileErrors: []},
                meta: {
                  roles: ['admin']
                },
            },
            {
                path: 'connection',
                name: 'OrganizationConnection',
                component: OrganizationConnection
            },
        ]
    },
  {
    path: '/contr-agents',
    component: Layout,
    meta: {
      roles: ['admin']
    },
    children: [
      {
        path: 'contacts',
        name: 'ContactsIndex',
        component: ContactsPage
      },
      {
        path: 'contacts/create',
        name: 'ContactCreatePage',
        component: ContactCreatePage
      },
      {
        path: 'contacts/:contactId/edit',
        name: 'ContactEditPage',
        component: ContactCreatePage
      },
      {
        path: 'jur/:jurId/contacts',
        name: 'JurContactsIndex',
        component: ContactsPage
      },
      {
        path: '/',
        name: 'ContrAgentsMain',
        component: ContrAgentsMain
      },
      {
        path: 'jur/create',
        name: 'JurCreatePage',
        component: JurEditPage
      },
      {
        path: 'jur/edit/:id',
        name: 'JurEditPage',
        component: JurEditPage
      },
      {
        path: 'jur/:jurId/contacts/create',
        name: 'JurContactCreatePage',
        component: ContactCreatePage
      },
      {
        path: 'jur/:jurId/contacts/:contactId/edit',
        name: 'JurContactEditPage',
        component: ContactCreatePage
      },
    ]
  },

  {
    path: '/maintenance',
    name: 'maintenances',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'maintenance',
        component: MaintenancePage
      },
    ]
  },
    {
    path: '/appeals',
    name: 'appeals',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'appeals.list',
        component: AppealsListPage
      },
      {
        path: 'connect',
        name: 'appeals.connect',
        component: AppealsConnectPage
      },
      {
        path: 'connect/pending',
        name: 'appeals.connect.pending',
        component: AppealsConnectionPendingPage
      },
    ]
  },
  {
    path: '/work-space',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'work_space',
        component: WorkSpacePage
      },
      {
        path: 'settings',
        name: 'workSpace.settings',
        component: WorkSpaceSettingsPage
      },
    ]
  },
  {
    path: '/admin',
    component: Layout,
    meta: {
      roles: ['admin']
    },
    children: [
      {
        path: 'export-request-statistic',
        name: 'ExportRequestStatistic',
        component: ExportRequestStatisticPage,
        meta: {}
      },
      // User
      {
        path: 'user/list',
        name: 'UserList',
        component: List,
        meta: {
          roles: ['']
        }
      },
      {
        path: 'user/add',
        name: 'UserAdd',
        component: Add
      },
      {
        path: 'user/edit',
        name: 'UserEdit',
        component: Edit
      },
      {
        path: 'workspaces',
        name: 'Admin/WorkspaceList',
        component: WorkspaceList
      },
      {
        path: 'errors/import-debt-responses',
        name: 'AdminImportDebtResponseErrors',
        component: AdminImportDebtResponseErrors
      },
    ],
  },

  {
    path: '/subscriptions',
    component: LayoutSubscription,
    meta: {
      roles: ['admin']
    },
    children: [
      {
        path: '',
        name: 'main_page',
        component: Subscriptions
      },
      {
        path: 'new',
        name: 'SubscriptionPage',
        component: SubscriptionPage
      },
      {
        path: 'details',
        name: 'SubscriptionDetailsPage',
        component: SubscriptionDetailsPage
      },
      {
        path: 'settings/:id',
        name: 'SubscriptionSettingsPage',
        component: SubscriptionSettingsPage
      },
      {
        path: 'settings/details/:id',
        name: 'SubscriptionSettingsDetailsPage',
        component: SubscriptionSettingsDetailsPage
      },
      {
        path: 'settings/pay/:id',
        name: 'SubscriptionSettingsPayPage',
        component: SubscriptionSettingsPayPage
      },

      {
        path: 'pay',
        name: 'SubscriptionPayPage',
        component: SubscriptionPayPage
      },
      {
        path: 'balance',
        name: 'SubscriptionBalancePage',
        component: SubscriptionBalance
      },
      {
        path: 'invoices',
        name: 'SubscriptionInvoicePage',
        component: SubscriptionInvoices
      },
      {
        path: 'invoices/download/:id',
        name: 'SubscriptionDownloadInvoice',
        component: SubscriptionDownloadInvoice
      },
      {
        path: 'success',
        name: 'successUrl',
        component: Subscriptions
      },

    ]
  },

  {
    path: '/403',
    name: 'Error403',
    component: Error403
  },
  {
    path: '*',
    name: 'Error',
    component: Error
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach(async (to, from, next) => {
  if(to.matched.some(route => route.meta.guest)){
      next();
  }else if(store.dispatch('auth/checkAuth')){
      if(to.matched.some(route => route.meta.roles)){
        await store.dispatch('user/loadingPromise');
        const hasRoles = store.getters['user/HAS_ROLES'];
        for(let matched of to.matched){
          if(matched.meta.roles && !hasRoles(matched.meta.roles)){
            next({ name: 'Error403' })
          }
        }
      }
      next();
  }else {
      next({name: 'Login'});
  }
});
export default router;
